export default __webpack_public_path__ + "static/media/bg.c7b98cad.png";